<template>
    <div id="rentalUtilizationEquipmentReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Rental Utilization Equipment Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content rental-utilization">
                        <data-table-filter-config :moduleName="'rentalUtilizationEquipment'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'rentalUtilizationEquipment'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="rentalUtilizationEquipment"
                                      mode="remote"
                                      title="News"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: false,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./../event-bus";
    import Vue from "vue";

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "RentalUtilizationEquipmentReport",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({

            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                 {
                    label: 'Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                 },
                 {
                    label: 'Asset Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: 'Asset Pool',
                    field: 'asset_pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Pool.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sts',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Days Available',
                    field: 'days_available',
                    fpFieldType:"number",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Days Available", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Days Active',
                    field: 'days_active',
                    fpFieldType:"number",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Days Active", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Utilization',
                    field: 'utilization',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Utilization", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Revenue',
                    field: 'revenue',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Revenue", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Fixed Revenue',
                    field: 'fixedRevenue',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Fixed Revenue", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Fixed Avg Daily Rate',
                    field: 'fixed_avg_daily_rate',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Fixed Revenue", // placeholder for filter input
                        filterDropdownItems: '',
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'rental_utilization_equipment_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            },
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.rentalUtilizationEquipment.unselectAllInternal();
            },
            // exportReports: function() {
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },

            loadList: function() {

                var self = this;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action
                };
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/rental-utilize-asset",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                            //   self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'rental-utilization-equipment-report')
                    }
                });
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/reports/RentalUtilizationEquipmentReport.vue